module.exports = __webpack_public_path__ + "static/media/Poker.8d5f373a.svg";